export enum HallowPromoCodeGroup {
  GiftCard = "gift_card",
}
